import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createBidProposal,
  getBidChanceDetail,
  getBidChanceDetail2,
  getBidChanceList,
  updateBidChance,
} from '../../api/constlink';
import {
  createBidProposalAsync,
  CREATE_BID_PROPOSAL,
  getBidChanceDetailAsync,
  getBidChanceListAsync,
  GET_BID_CHANCE_DETAIL,
  GET_BID_CHANCE_LIST,
  updateBidChanceAsync,
  UPDATE_BID_CHANCE,
  getBidChanceDetail2Async,
  GET_BID_CHANCE_DETAIL2,
} from './actions';
import { BidChance } from './types';

function* getBidChanceListSaga(
  action: ReturnType<typeof getBidChanceListAsync.request>,
) {
  try {
    const bidChances: BidChance[] = yield call(
      getBidChanceList,
      action.payload,
    );
    yield put(getBidChanceListAsync.success(bidChances));
  } catch (e: any) {
    yield put(getBidChanceListAsync.failure(e));
  }
}

/*
function* createBidChanceSaga(
  action: ReturnType<typeof createBidChanceAsync.request>,
) {
  try {
    const bidChance: BidChance = yield call(createBidChance, action.payload);
    yield put(createBidChanceAsync.success(bidChance));
  } catch (e: any) {
    yield put(createBidChanceAsync.failure(e));
  }
}
*/

function* updateBidChanceSaga(
  action: ReturnType<typeof updateBidChanceAsync.request>,
) {
  try {
    const bidChance: BidChance = yield call(updateBidChance, action.payload);
    yield put(updateBidChanceAsync.success(bidChance));
  } catch (e: any) {
    yield put(updateBidChanceAsync.failure(e));
  }
}

/*
function* deleteBidChanceSaga(
  action: ReturnType<typeof deleteBidChanceAsync.request>,
) {
  try {
    yield call(deleteBidChance, action.payload);
    yield put(deleteBidChanceAsync.success(action.payload.id));
  } catch (e: any) {
    yield put(deleteBidChanceAsync.failure(e));
  }
}
*/

function* getBidChanceDetailSaga(
  action: ReturnType<typeof getBidChanceDetailAsync.request>,
) {
  try {
    const bidChance: BidChance = yield call(getBidChanceDetail, action.payload);
    yield put(getBidChanceDetailAsync.success(bidChance));
  } catch (e: any) {
    yield put(getBidChanceDetailAsync.failure(e));
  }
}

function* createBidProposalSaga(
  action: ReturnType<typeof createBidProposalAsync.request>,
) {
  try {
    const bidChance: BidChance = yield call(createBidProposal, action.payload);
    yield put(createBidProposalAsync.success(bidChance));
  } catch (e: any) {
    yield put(createBidProposalAsync.failure(e));
  }
}

function* getBidChanceDetail2Saga(
  action: ReturnType<typeof getBidChanceDetail2Async.request>,
) {
  try {
    const bidChance: BidChance = yield call(
      getBidChanceDetail2,
      action.payload,
    );
    yield put(getBidChanceDetail2Async.success(bidChance));
  } catch (e: any) {
    yield put(getBidChanceDetail2Async.failure(e));
  }
}

export function* bidChancesSaga() {
  yield takeLatest(GET_BID_CHANCE_LIST, getBidChanceListSaga);
  yield takeLatest(UPDATE_BID_CHANCE, updateBidChanceSaga);
  yield takeLatest(GET_BID_CHANCE_DETAIL, getBidChanceDetailSaga);
  yield takeLatest(CREATE_BID_PROPOSAL, createBidProposalSaga);
  yield takeLatest(GET_BID_CHANCE_DETAIL2, getBidChanceDetail2Saga);
}
